<template>
  <div class="ty-main">
    <div class="ty-tip">
      <div class="ty-img">
        <img src="../../assets/images/prompt.png" />
      </div>

      <div class="tip">
        管理员可以给员工设置的每天需要主动联系客户的数量
      </div>
    </div>
  <!--  <div class="ty-cha">
      <div class="top">
        <div
          class="wqe"
          @click="tabclick(0)"
          :style="tabindex === 0 ? 'border-bottom:3px solid #1152AD;color: #1152AD;' : ''"
        >
          员工列表
        </div>
        <div
           class="wqe"
           :style="tabindex === 1 ? 'border-bottom:3px solid #1152AD;color: #1152AD' : ''"
          @click="tabclick(1)"
        >
          任务列表
        </div>
      </div>
    </div> -->
    <div class="ty-tabs">
      <template v-for="(item, index) in tabs">
        <div
          class="tab-item"
          :key="index"
          :class="{ active: tabindex === index }"
          @click="tabclick(index)"
        >
          {{ item.title }}
        </div>
      </template>
    </div>
    <Peoples v-if="tabindex === 0"></Peoples>
    <Tasks v-if="tabindex === 1"></Tasks>
  </div>
</template>
<script>
import Peoples from './components/Peoples'
import Tasks from './components/Tasks'
export default {
  components: {
    Peoples,
    Tasks
  },
  data() {
    return {
      tabs: [
        {
          title: '员工列表'
        },
        {
          title: '任务列表'
        }
      ],
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      department_id: '',
      status: '',
      tabindex: 0,
      total: 0,
      loading: false,
      radio: 0,
      ke_name: '',
      dialogVisible: false,
      searchForm: {
        employee: ''
      },
      openTitle: ['会话存档开启中', '会话存档已关闭', '未开通会话存档'],
      isDepartmentDialog: false
    }
  },
  mounted() {
  //  this.taskList()
  },
  methods: {
    tabclick(index) {
      if (index !== this.tabindex) {
        this.tabindex = index
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      var newArr = []
      for (var i = 0; i < this.multipleSelection.length; i++) {
        newArr.push(this.multipleSelection[i].ke_name)
      }
    },
    operation() {},
    taskList() {
      this.loading = true
      const { clientName, userId } = this.searchForm
      this.$api
        .get('/api/v1/share/index', {
          page: this.currentPage,
          ke_name: clientName,
          // st_user_id: '',
          // department_id: '',
          // status: '',
          // is_all: sessionStorage.getItem('isAll') || 1,
          user_id: userId
        })
        .then((res) => {
          // const tableData = res
          // res.list.forEach(v => {
          //   v.people = []
          //   v.onStaff = []
          //   v.leaveStaff = []
          //   v.user_itme.forEach(item => {
          //     if (item.type === 1) {
          //       // item.status === 1 ? v.onStaff.push(item) : v.leaveStaff.push(item)
          //       item.status === 5 ? v.leaveStaff.push(item) : v.onStaff.push(item)
          //     } else {
          //       v.client = item
          //     }
          //     item.chartDataCode = 2
          //     res.user_authority.includes(item.user_id) && (item.chartDataCode = 0)
          //     res.user_expire_authority.includes(item.user_id) && (item.chartDataCode = 1)
          //   })
          //  })

          this.tableData = res.list
          this.total = res.total
          this.loading = false
        })
    },
    changeState(row) {
      const state = row.is_open_status
      this.$confirm(`确定${state ? '关闭' : '开启'}该客户的会话共享吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        closeOnClickModal: false
      })
        .then(() => {
          const tokenList = []
          const idList = []
          row.user_itme
            .filter((v) => v.type === 1)
            .forEach((item) => {
              tokenList.push(item.user_token)
              idList.push(item.user_id)
            })

          this.$api
            .post('/api/sharing/setting', {
              user_token_list: tokenList,
              user_id_list: idList,
              kehu_token: row.client.user_token,
              kehu_id: row.client.user_id,
              setting_type: state ? 2 : 1
            })
            .then(() => {
              this.$message({
                message: `${state ? '关闭' : '开启'}成功！`,
                type: 'success'
              })
              this.taskList()
            })
        })
        .catch(() => {})
    },
    onSearch() {
      this.currentPage = 1
      this.taskList()
    },
    employeeClear() {
      this.searchForm.employee = ''
      this.searchForm.userId = ''
    },
    // 选择员工分配
    checkUser(checkedDepartment, checkedEmployee) {
      if (checkedEmployee === '') {
        this.isDepartmentDialog = false
        return false
      }
      if (checkedEmployee && checkedEmployee.length) {
        this.searchForm.employee = checkedEmployee[0].name
        this.searchForm.userId = checkedEmployee[0].user_id
        this.isDepartmentDialog = false
      } else {
        this.$message.warning('请选择员工！')
      }
    },
    currentChange(val) {
      this.loading = true
      this.currentPage = val
      this.taskList()
    }
  }
}
</script>

<style lang="scss" scoped>
.ty-card {
  padding-bottom: 5px;
}
.el-card {
  position: relative;
  height: 500px;
  overflow: auto;
  box-shadow: none;
}
.el-tag {
  margin: 0 10px 10px 0;
}

.user-td {
  img {
    border-radius: 2px;
    border: 1px solid rgba(32, 74, 158, 0.48);
    vertical-align: middle;
    margin-right: 5px;
  }
}
.user-list {
  display: flex;
  flex-wrap: wrap;

  .user-bg {
    position: relative;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    margin: 5px 0 5px 20px;
    border-radius: 4px;

    .msg-icon {
      position: absolute;
      top: -2px;
      left: -10px;
      width: 24px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      border-radius: 50%;
      background: #fff;
      box-shadow: 0px 2px 10px 0px rgba(2, 47, 50, 0.1);
    }

    &.normal {
      padding: 0 10px 0 20px;
      background: rgba(4, 29, 52, 0.06);
      .msg-icon {
        color: #c8c8c8;
      }
    }

    &.active {
      padding: 0 10px 0 20px;
      background: rgba(0, 145, 255, 0.1);
      color: #0091ff;
      .msg-icon {
        color: #0091ff;
      }
    }
  }
}
.wx-text {
  color: #46bb36;
}
.corp-text {
  color: #ff9c6e;
}
.badge {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #46bb36;

  &.danger {
    background: #ee2928;
  }
}
.top {
  // width: 98%;
  // margin: 0 1%;
  // height: 80px;
  // background-color: white;
  display: flex;
  height: 5rem;
  padding-left: 1.25rem;
  .wqe {
    width: 89px;
    text-align: center;
    line-height: 80px;
    font-weight: 500;
    margin-right: 30px;
    font-size: 18px;
    color: #303133;
  }
  .wqe::before {
    content: '';
    position: absolute;
    top: 222px;
    left: 366px;
    width: 80px;
    height: 3px;
    background: #204a9e;
    border-radius: 3px 3px 0px 0px;
  }
}
.ty-tabs .tab-item.active::before {
  content: '';
  position: absolute;
  top: 77px;
  left: 5px;
  width: 80px;
  height: 3px;
  background: #204a9e;
  border-radius: 3px 3px 0px 0px;
}
::v-deep .ty-tabs .tab-item{
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #303133;
  margin-left: 20px;
}
::v-deep .ty-tabs .tab-item:hover{
  color: #204A9E;
}
::v-deep .ty-tabs .tab-item.active{
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 550;
  color: #204A9E;
}
</style>
